import axios from "axios";
import React, { useEffect, useState } from "react";
import { UseHrApp } from "../../utils/context";
import LeavesModal from "./LeavesModal";

export default function LeavesLg() {
  const { token } = UseHrApp();

  const [leaves, setleaves] = useState([]);
  const [filteredLeaves, setFilteredLeaves] = useState([]);
  const [statusFilter, setStatusFilter] = useState(null);

  const filterLeavesByStatus = (status) => {
    if (status === statusFilter) {
      // If the same filter is clicked again, clear the filter
      setFilteredLeaves(leaves);
      setStatusFilter(null);
    } else {
      // Otherwise, apply the filter
      setFilteredLeaves(leaves.filter((item) => item.status === status));
      setStatusFilter(status);
    }
  };

  async function getAllLeaves() {
    try {
      const res = await axios({
        url: "https://hr-app-api.onrender.com/leave/all",
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res?.data?.status) {
        setleaves(res?.data?.data.reverse());
      }
    } catch (error) {
      console.log("Failed");
    }
  }

  useEffect(() => {
    getAllLeaves();
    setFilteredLeaves(leaves);
  }, []);

  console.log(filteredLeaves)
  return (
    <div>
      <div className="container mx-auto hidden lg:block ">
        <div className=" mb-[1em]">
          <p>Filter by:</p>
          <div className=" flex gap-3 mt-[1em]">
          <button
            onClick={() => filterLeavesByStatus("Approved")}
            className={`px-4 py-2 ${
              statusFilter === "Approved"
                ? "bg-green-500 text-white"
                : "bg-gray-300 text-gray-800"
            } rounded`}
          >
            Approved
          </button>
          <button
            onClick={() => filterLeavesByStatus("Pending")}
            className={`px-4 py-2 ${
              statusFilter === "Pending"
                ? "bg-yellow-500 text-white"
                : "bg-gray-300 text-gray-800"
            } rounded`}
          >
            Pending
          </button>
          <button
            onClick={() => filterLeavesByStatus("Rejected")}
            className={`px-4 py-2 ${
              statusFilter === "Rejected"
                ? "bg-red-500 text-white"
                : "bg-gray-300 text-gray-800"
            } rounded`}
          >
            Rejected
          </button>
          </div>
        </div>
        {filteredLeaves.length === 0 ? (
          <p>No Leaves Added</p>)
          :(
        <table className="min-w-full divide-y divide-gray-200">
          <thead>
            <tr>
              <th className="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                index
              </th>
              <th className="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                Employee Name
              </th>
              <th className="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                Start Date
              </th>
              <th className="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                End Date
              </th>
              <th className="px-6 py-3  bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                Status
              </th>
              <th className="px-6 py-3  bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                More
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {filteredLeaves.map((item, index) => (
              <tr key={item.id}>
                <td className="px-4 py-4 whitespace-no-wrap">{index}</td>
                <td className="px-4 py-4 whitespace-no-wrap">
                  {" "}
                  {item.employee.firstname} {item.employee.lastname}{" "}
                </td>
                <td className="px-4 py-4 whitespace-no-wrap">
                  {new Date(item.startDate).toISOString().slice(0, 10)}
                </td>
                <td className="px-4 py-4 whitespace-no-wrap">
                  {new Date(item.endDate).toISOString().slice(0, 10)}
                </td>
                <td className={"px-4 py-1  whitespace-no-wrap"}>
                  <div
                    className={
                      item.status === "Approved"
                        ? "h-6 text-[#32bd67] text-center bg-[#eaedf1] rounded-[3em]"
                        : item.status === "Rejected"
                        ? "bg-[#f9d0d0] h-6 text-[#ff0000] text-center rounded-[3em]"
                        : "bg-[#f1f3f5] h-6 text-[#e2bc3e] text-center rounded-[3em]"
                    }
                  >
                    {item.status}
                  </div>
                </td>
                <td className="px-4 py-4 whitespace-no-wrap">
                  <LeavesModal key={item.id} {...item} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>)}
      </div>
    </div>
  );
}

/**
 *      <div className=" flex gap-2">
                    <button className="  w-max p-[2px] flex items-center justify-center bg-[#daeaff] "     onClick={()=>{
                   
                    }}>
                      <AiOutlineEye color="black" />{" "}
                    </button>
          
                  </div>
 */
